/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import _ from 'lodash';
import clsx from 'clsx';

interface Props {
  className?: string;
  children?: React.ReactNode;
  /**
   * the id of the input this is for
   */
  labelFor?: string;
  'data-testid'?: string;
  field?: ReduxFormField<any>;
  hint?: string | React.ReactNode;
  labelId?: string;
  label?: string | JSX.Element;
  labelOptional?: boolean;
  disabled?: boolean;
  error?: React.ReactNode;
  // field.error blocks form submission
  // "warn" does not block form submission
  // Redux 6.01  has built-in support for warn - currently on Redux 5
  warn?: string;
  valid?: string;
  // Redux 5 has an issue with how our booking modal passes in the props
  // and resets the "touched" value of the fields.
  // https://github.com/erikras/redux-form/issues/1130
  showErrorOnUntouchedField?: boolean;
}

/**
 * @deprecated
 * This is now built into inputs located in the ui folder of your project
 */
export default class Field extends React.PureComponent<Props> {
  static defaultProps: Partial<Props> = {
    disabled: false,
  };

  render() {
    const {
      children,
      className,
      disabled,
      error,
      field,
      hint,
      label,
      labelId,
      labelFor,
      labelOptional,
      showErrorOnUntouchedField,
      warn,
      valid,
    } = this.props;

    const hasError = showErrorOnUntouchedField
      ? field && field.error && !_.isEmpty(_.trim(field.error))
      : field && field.touched && field.error && !_.isEmpty(_.trim(field.error));

    const hasWarning = field && field.touched && warn && !_.isEmpty(_.trim(warn));
    const hasValid = field && field.touched && valid && !_.isEmpty(_.trim(valid));
    const finalClassName = clsx('Field', className, {
      'Field--disabled': disabled,
    });
    return (
      <div className={finalClassName} data-testid={this.props['data-testid']}>
        {label && (
          <label id={labelId} className="Label" key="Label" htmlFor={labelFor}>
            {label}
            {labelOptional && <span className="Label-optional">Optional</span>}
          </label>
        )}

        {children}

        {(hasError || error) && (
          <div className="Errors" key="Errors">
            <div
              className="Error"
              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
              id={field ? 'error_' + field!.name : undefined}
              aria-live="polite"
              data-testid={
                this.props['data-testid'] ? this.props['data-testid'] + '-error' : undefined
              }
            >
              {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                error ? error : field!.error
              }
            </div>
          </div>
        )}

        {((!hasError && hasWarning) || (!error && warn)) && (
          <div className="Warnings" key="Warnings">
            <div
              className="Warning"
              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
              id={field ? 'error_' + field!.name : undefined}
              aria-live="polite"
              data-testid={
                this.props['data-testid'] ? this.props['data-testid'] + '-warning' : undefined
              }
            >
              {warn}
            </div>
          </div>
        )}

        {((!hasError && hasValid) || (!error && valid)) && (
          <div className="Valids" key="Valids">
            <div className="Valid">{valid}</div>
          </div>
        )}

        {hint && (
          <div className="Hints" key="Hints">
            <div className="Hint">{hint}</div>
          </div>
        )}
      </div>
    );
  }
}
